"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dependency = void 0;
const inversify_1 = require("inversify");
/**
 * Dependency decorator.
 *
 * @param constructor - The constructor of the plugin or module to inject.
 */
const Dependency = (constructor) => inversify_1.inject(constructor);
exports.Dependency = Dependency;
//# sourceMappingURL=decorator.js.map